import { AbstractGridStrategy } from './abstract.strategy';
import { ResizeSensor } from 'css-element-queries';

export class StretchGridStrategy extends AbstractGridStrategy {
    private sensor: ResizeSensor;
    private rowWeight: number;

    constructor(
        gridParentElement: HTMLElement = null,
        rowWeight: number = 1,
        private rowHeight?: number
    ) {
        super();

        this.rowHeight = this.rowHeight || this.a9GridConstants.dataRowHeight;
        this.rowWeight = rowWeight;
        if (gridParentElement !== null) {
            this.bindToElement(gridParentElement);
        }
        this.addClass('listing-grid-v1__stretch');
    }

    protected bindToElement(element: HTMLElement): void {
        this.gridHeight = element.clientHeight;
        this.sensor = new ResizeSensor(element, () => {
            this.gridHeight = element.clientHeight;
            this.emit('gridStrategy::changeHeight', this.gridHeight);
        });
    }

    public getGridHeight(): number {
        return this.gridHeight;
    }

    public getGridPageAmount(): number {
        let freeSpace = this.getGridHeight();
        if (this.headerHeight) {
            freeSpace -= this.headerHeight;
        }
        let amount = Math.floor(freeSpace / this.rowHeight);
        if (this.rowWeight > 1) {
            amount -= amount % this.rowWeight;
        }

        if (this.rowWeight > 0 && this.rowWeight < 1) {
            amount = Math.floor(amount * this.rowWeight);
        }

        return amount;
    }

    public showPagination() {
        return true;
    }

    public detach() {
        this.sensor.detach();
        delete this.sensor;
    }

    public setGridElement(gridElement: HTMLElement): void {
        if (!this.sensor) {
            this.bindToElement(gridElement);
        }
    }
}
